import { WebviewId } from '@gitlab-org/webview-plugin';
import { FastifyInstance, FastifyReply, FastifyRequest, RouteHandlerMethod } from 'fastify';
import { withTrailingSlashRedirect } from '../../http';

export const buildWebviewRequestHandler = (
  webviewIds: WebviewId[],
  getWebviewResourcePath: (webviewId: WebviewId) => string,
): RouteHandlerMethod => {
  return withTrailingSlashRedirect(
    withKnownWebview(webviewIds, async (request: FastifyRequest, reply: FastifyReply) => {
      const { webviewId } = request.params as { webviewId: WebviewId };
      const webviewPath = getWebviewResourcePath(webviewId);
      try {
        await reply.sendFile('index.html', webviewPath);
      } catch (error) {
        request.log.error(error, 'Error loading webview content');
        await reply.status(500).send('Failed to load the webview content.');
      }
    }),
  );
};

export const withKnownWebview = (
  webviewIds: WebviewId[],
  handler: RouteHandlerMethod,
): RouteHandlerMethod => {
  return function (this: FastifyInstance, request: FastifyRequest, reply: FastifyReply) {
    const { webviewId } = request.params as { webviewId: WebviewId };

    if (!webviewIds.includes(webviewId)) {
      return reply.status(404).send(`Unknown webview: ${webviewId}`);
    }

    return handler.call(this, request, reply);
  };
};
